import { NEED_MORE_INFO } from "../../shared/instantAnswerUtils";
import { getDeliveredAtDateFromIAContext } from "../../utils/getDeliveredAtDateFromIAContext";
import { orderCanBeReportedBasedOnDeliveryDate } from "../../utils/orderCanBeReportedBasedOnDeliveryDate";
import { GoToBrandReferralsCTA, GoToFairePosCTA, ReportItemsCTA, RequestExtensionCTA, VerifyAccountCTA, ViewInvoicesCTA, ViewOrUpdatePaymentMethodsCTA, ViewOrderInvoiceCTA } from "./ctas";
export var NEED_MORE_INFO_ANSWER = function NEED_MORE_INFO_ANSWER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return NEED_MORE_INFO(strictLocalize);
    },
    getDescription: function getDescription() {
      return [CHECKOUT_OUR_ARTICLES(strictLocalize)];
    }
  };
};
var CHECKOUT_OUR_ARTICLES = function CHECKOUT_OUR_ARTICLES(strictLocalize) {
  return strictLocalize({
    id: "cHcJWP",
    defaultMessage: "Check out some recommended articles from our Help Center below, or contact us if you need more help."
  });
};
export var INELIGIBLE_FOR_REPORT = function INELIGIBLE_FOR_REPORT(strictLocalize) {
  return strictLocalize({
    id: "cVWbfo",
    defaultMessage: "Your 14-day period to report damaged, missing, or incorrect items for this order has passed"
  });
};
export var DO_NOT_PROCESS_DAMAGED_AS_RETURN = function DO_NOT_PROCESS_DAMAGED_AS_RETURN(strictLocalize) {
  return strictLocalize({
    id: "9FSbe7",
    defaultMessage: "Note: Please do not process damaged items as a “return” to avoid being charged at a later date."
  });
};
export var TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE = function TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize) {
  return strictLocalize({
    id: "xNgrP9",
    defaultMessage: "Please note that VAT, excise taxes, and other fees are not covered by Faire."
  });
};
export var getReportItemsOrRequestExtensionCTA = function getReportItemsOrRequestExtensionCTA(context, strictLocalize) {
  var brandOrder = context.brandOrder,
    shippingContext = context.shippingContext;
  var deliveredAt = getDeliveredAtDateFromIAContext(context);
  if (!brandOrder || !shippingContext || !deliveredAt) {
    return undefined;
  }
  return orderCanBeReportedBasedOnDeliveryDate(deliveredAt) ? ReportItemsCTA(strictLocalize) : RequestExtensionCTA(strictLocalize);
};
export var getVerifyAccountCTA = function getVerifyAccountCTA(_context, strictLocalize) {
  return VerifyAccountCTA(strictLocalize);
};
export var getGoToFairePosCTA = function getGoToFairePosCTA(_context, strictLocalize) {
  return GoToFairePosCTA(strictLocalize);
};
export var getViewOrderInvoiceCTA = function getViewOrderInvoiceCTA(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return undefined;
  }
  return ViewOrderInvoiceCTA(strictLocalize, brandOrder);
};
export var getViewSingleOrMultipleInvoicesCTA = function getViewSingleOrMultipleInvoicesCTA(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ViewInvoicesCTA(strictLocalize);
  }
  return ViewOrderInvoiceCTA(strictLocalize, brandOrder);
};
export var getViewAndUpdatePaymentMethodsCTA = function getViewAndUpdatePaymentMethodsCTA(_context, strictLocalize) {
  return ViewOrUpdatePaymentMethodsCTA(strictLocalize);
};
export var getGoToBrandReferralsCTA = function getGoToBrandReferralsCTA(_context, strictLocalize) {
  return GoToBrandReferralsCTA(strictLocalize);
};